<template>
  <v-tooltip bottom :color="colorTooltip" :disabled="disableTooltip">
    <template v-slot:activator="{ on }">
      <v-btn
        v-bind="$attrs"
        :aria-label="currentTooltip"
        class="text-none"
        :class="className"
        :color="color || defaultBtn.color"
        :depressed="depressed"
        :fab="fab"
        :icon="icon"
        :rounded="rounded"
        v-on="{ ...$listeners, ...on }"
      >
        <slot>
          <template v-if="defaultBtn.icon && !noIcon">
            <v-icon
              v-if="!depressed"
              v-bind="bindIcon"
              :left="!isIcon"
              :color="color || defaultBtn.color"
              >{{ defaultBtn.icon }}</v-icon
            >
            <v-icon v-else v-bind="bindIcon" :left="!isIcon">{{
              defaultBtn.icon
            }}</v-icon>
          </template>
          <template v-if="!isIcon && defaultBtn.title">
            <span>{{ currentTooltip }}</span>
          </template>
        </slot>
      </v-btn>
    </template>
    <slot name="tooltip">
      <span>{{ tooltip || currentTooltip }}</span>
    </slot>
  </v-tooltip>
</template>

<script>
import { defaultTypeButon } from '@src/constant'
export default {
  name: 'base-button',
  inheritAttrs: false,
  props: {
    bindIcon: {},
    noIcon: Boolean,
    tooltip: String,
    fab: Boolean,
    icon: Boolean,
    colorTooltip: String,
    classBtn: String,
    typeAction: {
      type: String,
      validator: function(value) {
        return Object.keys(defaultTypeButon).includes(value)
      },
    },
    color: String,
    className: String,
    depressed: { type: Boolean, default: true },
    useTooltip: Boolean,
    rounded: { default: true },
  },
  data: () => ({
    defaultBtn: {},
  }),
  computed: {
    currentTooltip() {
      return this.tooltip || this.defaultBtn.title
    },
    disableTooltip() {
      if (this.useTooltip) return false
      return !this.isIcon || (!this.currentTooltip && !this.$slots.tooltip)
    },
    isIcon() {
      return this.icon || this.fab
    },
  },
  watch: {
    typeAction: {
      handler(value) {
        if (value) {
          this.defaultBtn = defaultTypeButon[value] || {}
        }
      },
      immediate: true,
    },
  },
}
</script>
